import { useSearchParams } from "react-router";

import { CourseRosterManager } from "@/components/enrollment/CourseRosterManager";
import type { Course } from "@/lib/api/courses";
import { admissionsOriginFromSearch } from "@/lib/registrar-origin";

/**
 * Shared by the section record and its full Roster view (`?view=roster`).
 * The course in the path owns every enrollment and roster act.
 *
 * An Admissions handoff (`student`, with `origin` and `applicant`) seeds the
 * plan with that student, and `enrollment-notice` opens the exact notice
 * record beside the roster row it belongs to.
 */
export function RegistrarCourseRoster({ course, presentation = "manage" }: { course: Course; presentation?: "setup" | "manage" }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const handoffStudentId = searchParams.get("student");
  const admissionsOrigin = admissionsOriginFromSearch(searchParams);
  const noticeId = searchParams.get("enrollment-notice");

  return (
    <section aria-label="Build roster" className="grid min-w-0 gap-4">
      <CourseRosterManager
        courseId={course.id}
        section={course}
        presentation={presentation}
        initialStudentId={handoffStudentId}
        admissionsOrigin={admissionsOrigin}
        initialNoticeId={noticeId}
        onOpenNotice={(id) => setSearchParams((current) => {
          const next = new URLSearchParams(current);
          next.set("enrollment-notice", id);
          return next;
        })}
        onCloseNotice={() => setSearchParams((current) => {
          const next = new URLSearchParams(current);
          next.delete("enrollment-notice");
          return next;
        })}
      />
    </section>
  );
}
